import 'core-js'
import { container, Lifecycle } from 'tsyringe'
import App from '@/ux/App.vue'
import router from '@/router'
import { Interface } from '@/shared/di/interface'
import { IAssets } from '@/shared/di/interface/assets'
import { ISound } from '@/shared/di/interface/sound'
import { IDebug } from '@/shared/di/interface/debug'
import { TouchManager } from '@/shared/manager/touch'
import { SizeManager } from '@/shared/manager/size'
import { AssetsManager } from '@/shared/manager/assets'
import { SoundManager } from '@/shared/manager/sound'
import gsap, { Draggable } from 'gsap/all'
import globalSoundMap from '@/shared/configs/global-sounds.json'
import { createApp } from 'vue'
import { DebugManager } from './shared/manager/debug'

gsap.registerPlugin(Draggable)

declare global {
  interface Window {
    InertiaPlugin: any
  }
}

gsap.registerPlugin(window.InertiaPlugin)

// Singleton (each resolve will return the same instance)
container.register(Interface.ITouch, { useClass: TouchManager }, { lifecycle: Lifecycle.Singleton })
container.register(Interface.ISize, { useClass: SizeManager }, { lifecycle: Lifecycle.Singleton })
container.register(Interface.IAssets, { useClass: AssetsManager }, { lifecycle: Lifecycle.Singleton })
container.register(Interface.ISound, { useClass: SoundManager }, { lifecycle: Lifecycle.Singleton })
container.register(Interface.IDebug, { useClass: DebugManager }, { lifecycle: Lifecycle.Singleton })
container.register(Interface.INavigation, { useValue: router })

//Vue.config.productionTip = false

const init = async () => {
  const assets = container.resolve<IAssets>(Interface.IAssets)
  const sound = container.resolve<ISound>(Interface.ISound)
  const debug = container.resolve<IDebug>(Interface.IDebug)

  sound.registerSoundMap('global', globalSoundMap)

  //TODO: Add tests that mock different issues in any of these managers

  assets.init().then(() => {
    debug.init().then(() => {
      startApp()
    })
  })
}

const reloadApp = () => {
  cwr('recordError', { type: 'app_start_fail_reload', data: { reason: 'could not load wallets' } })
  window.setTimeout(() => {
    window.location.reload()
  }, 4000)
}

const startApp = () => {
  createApp(App).use(router).mount('#app')
}

init().catch(err => {
  throw new Error(err)
})
